import { render, staticRenderFns } from "./EducationalMaterial.vue?vue&type=template&id=0205ed48"
import script from "./EducationalMaterial.vue?vue&type=script&lang=js"
export * from "./EducationalMaterial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports